export default "__VITE_ASSET__DeSsmj$1__"